module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "spinner",
      "name": "Spinner"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_c('p', [_c('checkbox', {
    attrs: {
      "checked": _vm.fixed,
      "type": "info"
    },
    on: {
      "checked": function($event) {
        _vm.fixed = arguments[0]
      }
    }
  }, [_vm._v("fixed")])], 1), _vm._v(" "), _c('p', [_c('v-select', {
    attrs: {
      "options": ['sm', 'md', 'lg', 'xl']
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  })], 1), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.showRef
    }
  }, [_vm._v("show spinner (using ref)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.showGlobal
    }
  }, [_vm._v("show spinner (global)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.showModel
    }
  }, [_vm._v("show spinner (v-model)")])]), _vm._v(" "), _c('div', [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": _vm.size,
      "fixed": _vm.fixed,
      "text": "I will close in 2 secs"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)]), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <spinner ref=\"spinner\" global v-model=\"spinner\" size=\"lg\" fixed text=\"I will close in 2 secs\"></spinner>\n  ")]), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "javascript"
    }
  }, [_vm._v("\n    // using ref\n    this.$refs.spinner.show()\n    this.$refs.spinner.hide()\n    // using global events\n    this.$root.$emit('spinner::show')\n    this.$root.$emit('spinner::hide')\n    // using v-model\n    this.spinner = true //show\n    this.spinner = false //hide\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("fixed")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("false")])]), _vm._v(" "), _c('p', [_vm._v("Set to true if you want the spinner to occupy the entire window space.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("global")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("false")])]), _vm._v(" "), _c('p', [_vm._v("When is true, set global events for that spinner. Will be ignored if was set another global spinner.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("size")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("sm")]), _vm._v(", "), _c('code', [_vm._v("md")]), _vm._v(", "), _c('code', [_vm._v("lg")]), _vm._v(", "), _c('code', [_vm._v("xl")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("md")])]), _vm._v(" "), _c('p', [_vm._v("The size of the spinner.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("text")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("''")])]), _vm._v(" "), _c('p', [_vm._v("The text to show under the spinner.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37c39708", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37c39708!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/spinnerDocs.vue
// module id = 263
// module chunks = 0